module.exports = __webpack_public_path__ + "static/media/paulfrankenhuizen.c124ec27.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/paulfrankenhuizen.webp
// module id = 396
// module chunks = 0